<template>
	<!-- :title="isEdit ? '编辑债权人' : '添加债权人'" -->
    <el-dialog
        :visible.sync="creditorDialogVisible"
        width="460px"
        center
        v-if="creditorDialogVisible"
        :before-close="cancelDialog"
    >
	<div class="" slot="title" style="text-align: left;font-size: 20px;font-family: PingFang SC Medium-, PingFang SC Medium;font-weight: normal;color: #282F36;line-height: 25px;">
		{{isEdit ? '编辑直播人' : '添加直播人'}}
	</div>
        <el-form :model="creditorForm" status-icon ref="ruleForm" label-width="120px" class="demo-ruleForm" :rules="rules" label-position="left">
            <el-form-item label="用户名" prop="name" v-if="isShow">
                <el-input type="text" v-model="creditorForm.name" autocomplete="off" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="账户" prop="username">
                <el-input type="text" v-model="creditorForm.username" autocomplete="off" placeholder="请输入账户"></el-input>
            </el-form-item>
           <el-form-item label="手机号" prop="phone">
               <el-input type="text" v-model="creditorForm.phone" autocomplete="off" placeholder="请输入手机号"></el-input>
           </el-form-item>
		   <el-form-item label="密码" prop="cypher">
		       <el-input type="text" v-model="creditorForm.cypher" autocomplete="off" placeholder="请输入密码"></el-input>
		   </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
			<!-- type="primary"  -->
            <el-button style="width: 120px;" @click="cancelDialog" plain>取消</el-button>
			<!-- style="background:#de4d2a !important" -->
            <el-button style="width: 120px;" type="primary" @click="addorEditUser('ruleForm')" :loading="loading">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { addCreatorUser, editUser, editMeetingUser } from '@/serve/user';
import {
		getStreamerList,
		getStreamerListCount,
		addStreamerList,
		editStreamerList,
		addsStreamerList,
	} from '@/serve/streamerList';

export default {
    components: {},
    props: {
        creditorDialogVisible: Boolean,
        creditorForm: Object,
        isEdit: Boolean,
        meetingId: String,
        userId: String,
        isType: {
            type: Boolean,
            default: true
        },
        isShow: {
            type: Boolean,
            default: true
        },
        // 判断是哪个菜单下的编辑
        isKey: {
            type: Boolean,
            default: false
        }
    },
    data() {
        let checkPhone = (rule, value, callback) => {
            let reg = /^1[3456789]\d{9}$/;
            if (!reg.test(value)) {
                callback(new Error('请输入11位手机号'));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            rules: {
                name: [{ required: true, message: '请填写用户名', trigger: 'blur' }],
                // phone: [{ required: true, message: '请填写正确的手机号', validator: checkPhone, trigger: 'blur' }],
                username: [{ required: true, message: '请填写账户', trigger: 'blur' }],
                // cypher: [{ required: true, message: '请填写密码', trigger: 'blur' }]
            },
        };
    },
    methods: {
        // 取消
        cancelDialog() {
            this.$emit('cancel');
        },
        // 调用成功
        callSuccess(flag = false) {
            this.$message.success(flag ? '编辑成功' : '创建成功');
            this.cancelDialog();
            this.$emit('refreshList');
            this.loading = false;
        },
        // 调用失败
        callError(flag = false) {
            this.$message.error(flag ? '编辑失败' : '创建失败');
            this.loading = false;
            // this.cancelDialog();
        },
        // 确定
        addorEditUser(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                   
                    if (this.isEdit) {
                         // 编辑
						 console.log("this.creditorForm",this.creditorForm)
						 console.log("this.meetingId",this.meetingId)
						 if (this.isKey) {
						     editStreamerList(this.userId, this.meetingId, this.creditorForm).then(() => {
						            this.callSuccess(true);
						        })
						        .catch(err => {
						            this.$message.error(err.data.message);
						            this.loading = false;
						            this.cancelDialog(true);
						        });
						 } else {
						     editUser(this.userId, this.creditorForm)
						         .then(() => {
						             this.callSuccess(true);
						         })
						         .catch(err => {
						             this.callError(true);
						         });
						 }
                    } else {
                        // 新增
						console.log("this.creditorForm",this.creditorForm)
                        addStreamerList(this.meetingId, this.creditorForm)
                            .then(() => {
                                this.callSuccess(false);
                            })
                            .catch(err => {
                                this.$message.error(err.data.message);
                                this.loading = false;
                                this.cancelDialog(false);
                            });
                    }
                }
            });
        }
    }
};
</script>
